import PropTypes from 'prop-types';
import CustomLongField from './custom-long-field';
import CustomDateField from './custom-date-field';
import CustomBooleanField from './custom-boolean-field';
import CustomStringField from './custom-string-field';
import CustomDoubleField from './custom-double-field';
import { FieldWrapper } from '@evertrue/sdk';

const CustomField = (props) => {
  const { displayName = '', dataType } = props.customField;

  return (
    <FieldWrapper label={startCase(displayName)} inlineLabel={false} required={props.required} testId="custom-field">
      {dataType === 'LONG' ? (
        <CustomLongField {...props} />
      ) : dataType === 'DATE' ? (
        <CustomDateField {...props} />
      ) : dataType === 'BOOLEAN' ? (
        <CustomBooleanField {...props} />
      ) : dataType === 'STRING' ? (
        <CustomStringField {...props} />
      ) : dataType === 'DOUBLE' ? (
        <CustomDoubleField {...props} />
      ) : null}
    </FieldWrapper>
  );
};

const startCase = (str) => str.replace(/\b\w/g, (char) => char.toUpperCase());

CustomField.propTypes = {
  value: PropTypes.any,
  required: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  customField: PropTypes.shape({
    id: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    dataType: PropTypes.string.isRequired,
    required: PropTypes.bool, // we would like to deprecate this in favor of the conditional field rules framework
    uiControlType: PropTypes.string,
  }).isRequired,
};

export default CustomField;
